module.exports = __webpack_public_path__ + "static/img/logo.7b9155a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 395
// module chunks = 1